import React, { useContext, useEffect, useState } from "react";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import { Link, useNavigate } from "react-router-dom";
import CalendarFilter from "../../components/common/CalenderFilter";
import PaginationComponent from "../../components/common/PaginationModal";
import { GetAdminNotificationList } from "../../services/Notification/NotificationApi";

const NotificationList = () => {
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  //Context
  const { setLoader } = useContext(LoaderContext);
  const { authDetails, pageSize, PanalModuleName } = useContext(AuthContext);

  const [selectedNotification, setSelectedNotification] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [RoleTypeSearch, setRoleTypeSearch] = useState("");
  const [servicesList, setServicesList] = useState([]);
  const [servicesListCount, setServicesListCount] = useState(-1);

  const openModal = (notification) => {
    setSelectedNotification(notification);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedNotification(null);
  };

  useEffect(() => {
    GetAdminNotificationListData();
  }, []);

  const GetAdminNotificationListData = async (
    i = 1,
    searchKeyword,
    fromDate,
    toDate
  ) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetAdminNotificationList({
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? RoleTypeSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
        fromDate: fromDate, // Use the passed fromDate or a default
        toDate: toDate, // Use the passed toDate or a default
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setServicesListCount(response.totalCount);
        setServicesList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const formatDate = (dateString) => {
    // Create a new Date object from the date string
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      // If the date is invalid, return a fallback string
      return "Invalid Date";
    }

    // Format the date to a readable string (e.g., "April 25, 2025, 10:23 AM")
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  return (
    <>
      <div className="z-10 space-y-6 mx-auto rep-width px-4">
        <div className="h-full bg-white shadow rounded-lg flex flex-col">
          {/* Header */}
          <div className="border-b px-4 py-2 flex justify-between items-center">
            <h2 className="text-16 font-semibold text-black">Notifications</h2>
          </div>

          {/* Filters */}
          <div className="p-4 border-b flex flex-wrap sm:flex-nowrap items-center justify-between gap-3">
            <CalendarFilter
              onDateChange={(fromDate, toDate) => {
                setFromDate(fromDate);
                setToDate(toDate);
                GetAdminNotificationListData(
                  1,
                  RoleTypeSearch,
                  fromDate,
                  toDate
                ); // Call the API with the selected dates
              }}
              toDate={toDate}
              setToDate={setToDate}
              fromDate={fromDate}
              setFromDate={setFromDate}
            />

            {/* Search */}
            {/* <div className="relative flex items-center w-full sm:w-64">
                            <input
                                type="text"
                                className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                                placeholder="Search Notification"
                            />
                        </div> */}
          </div>

          {/* Notification List */}
          <div className="p-4 flex flex-col space-y-3 overflow-y-auto max-h-[70vh]">
            {servicesList.length === 0 ? (
              <p className="text-gray-500 text-center">
                No notifications found.
              </p>
            ) : (
              servicesList.map((notification) => (
                <div
                  key={notification.id}
                  onClick={() => openModal(notification)} // Uncommented to enable modal opening
                  className={`cursor-pointer p-4 rounded-lg shadow-sm border hover:shadow transition duration-200 ${
                    notification.isViewed ? "bg-gray-50" : "bg-white"
                  }`}
                >
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="text-14 font-semibold text-[#135EA0]">
                        {notification.title}
                      </h3>
                      <p className="text-12 text-gray-600 mt-1">
                        {notification.message.length > 60
                          ? notification.message.slice(0, 60) + "..."
                          : notification.message}
                      </p>
                      <div className="mt-2 flex items-center text-12 text-gray-400">
                        <span className="">
                          {formatDate(notification.dateTime)}{" "}
                          {/* Use the formatDate function here */}
                        </span>
                        {/* If you have an assignedBy field, you can uncomment the next line */}
                        {/* <span>Assigned by: {notification.assignedBy}</span> */}
                      </div>
                    </div>
                    {!notification.isViewed && (
                      <div className="bg-[#E86B1B] text-white text-12 rounded-full px-2 py-1">
                        New
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
          {/* Pagination */}
          {/* <div className="flex justify-end p-4">
            <PaginationComponent
              totalPages={2}
              currentPage={1}
              onPageChange={() => {}}
            />
          </div> */}
        </div>
      </div>

      {/* Modal */}
      {/* {showModal && selectedNotification && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
                        <button
                            onClick={closeModal}
                            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                        >
                            ✕
                        </button>
                        <h2 className="text-lg font-semibold text-[#135EA0] mb-4">
                            {selectedNotification.title}
                        </h2>
                        <p className="text-14 text-gray-700 mb-4">
                            {selectedNotification.message}
                        </p>
                        <div className="text-12 text-gray-500 mb-2">
                            <p><strong>Assigned by:</strong> {selectedNotification.assignedBy}</p>
                            <p><strong>Date:</strong> {selectedNotification.createdAt}</p>
                            <p><strong>Viewed:</strong> {selectedNotification.isViewed ? "Yes" : "No"}</p>
                        </div>
                        <div className="flex justify-end">
                            <button
                                onClick={closeModal}
                                className="px-4 py-2 bg-[#135EA0] text-white rounded  transition"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )} */}
    </>
  );
};

export default NotificationList;
